import { render, staticRenderFns } from "./PrintLayout.vue?vue&type=template&id=46a97cd9&scoped=true&lang=pug"
import script from "./PrintLayout.vue?vue&type=script&lang=js"
export * from "./PrintLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a97cd9",
  null
  
)

export default component.exports